module.exports = __webpack_public_path__ + "static/media/LibTech-min.da000367.webp";